import React, { type JSX } from 'react';

import { SERVICE_TYPE_CHOICES } from '@rover/constants/src/translations/service.constants';
import Boarding from '@rover/icons/svg/boarding.svg';
import Daycare from '@rover/icons/svg/daycare.svg';
import DogTraining from '@rover/icons/svg/dog-training.svg';
import DropIn from '@rover/icons/svg/drop-in.svg';
import Grooming from '@rover/icons/svg/grooming.svg';
import Sitting from '@rover/icons/svg/sitting.svg';
import Walking from '@rover/icons/svg/walking.svg';
import { Box } from '@rover/kibble/core';
import useTheme from '@rover/kibble/themes/useTheme';

const DEFAULT_CIRCLE_SIZE = 32;
const DEFAULT_ICON_SIZE = 25;

export const SERVICE_ICON_CONFIG = {
  [SERVICE_TYPE_CHOICES.boarding]: { Icon: Boarding, color: 'blue' },
  [SERVICE_TYPE_CHOICES.traveling]: { Icon: Sitting, color: 'blue' },
  [SERVICE_TYPE_CHOICES.dropIn]: { Icon: DropIn, color: 'orange' },
  [SERVICE_TYPE_CHOICES.dayCare]: { Icon: Daycare, color: 'orange' },
  [SERVICE_TYPE_CHOICES.walking]: { Icon: Walking, color: 'orange' },
  [SERVICE_TYPE_CHOICES.training]: { Icon: DogTraining, color: 'pink' },
  [SERVICE_TYPE_CHOICES.grooming]: { Icon: Grooming, color: 'pink' },
};

type ServiceIconProps = {
  serviceType: string;
  circleSize?: number;
  iconSize?: number;
};

const ServiceIcon = ({
  serviceType,
  circleSize = DEFAULT_CIRCLE_SIZE,
  iconSize = DEFAULT_ICON_SIZE,
}: ServiceIconProps): JSX.Element | null => {
  const theme = useTheme();
  const config = SERVICE_ICON_CONFIG[serviceType];
  if (!config) return null;

  const { Icon, color } = config;
  const iconInset = `${Math.round((circleSize - iconSize) / 2)}px`;

  return (
    <Box position="relative">
      <Box
        backgroundColor={theme.colors[color]['200']}
        borderRadius="round"
        width={`${circleSize}px`}
        height={`${circleSize}px`}
      />
      <Box position="absolute" top={iconInset} left={iconInset}>
        <Icon width={`${iconSize}px`} height={`${iconSize}px`} fill={theme.colors[color]['700']} />
      </Box>
    </Box>
  );
};

export default ServiceIcon;
